import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import { ButtonProps } from "@mui/material";
import { styled } from "@mui/material/styles";

const ProgressIcon = styled(CircularProgress)(() => ({
  color: '#999'
}));

interface Props extends ButtonProps {
  children: string;
  loading: boolean;
}

export default function LoadingButton(props: Readonly<Props>) {
  const { 
    loading,
    disabled,
    ...buttonProps 
  } = props;

  function getStartIcon() {
    if (loading && !props.endIcon)
      return <ProgressIcon disableShrink size={20} />;

    return props.startIcon;
  }

  function getEndIcon() {
    if (loading && props.endIcon && !props.startIcon)
      return <ProgressIcon disableShrink size={20} />;

    return props.endIcon;
  }

  return (
    <Button
      {...buttonProps}
      startIcon={getStartIcon()}
      endIcon={getEndIcon()}
      disabled={loading || disabled}>
      {props.children}
    </Button>
  );
}
